function setServices(data) {
	return {
		type: 'SET_SERVICES',
		payload: data,
	};
}

export { setServices };
